export default __webpack_public_path__ + "static/media/ETEF-10-11.f83199e3.pdf";